import React from 'react';
import config from '../../../../helpers/config';
import TrafficCone from '../../../../themes/svg/trafficCone';
import HomeIcon from '../../../../themes/svg/homeIcon';
import DrillIcon from '../../../../themes/svg/drillIcon';
import RightChevron from './RightChevron';


const CoveredByNobody = () => (
  <div className="covered-nobody-step">
    <div className="description">
      <div className="head-icon"><TrafficCone /></div>
      <h3>We&apos;re Sorry</h3>
      <p>
        Currently, we are not able to set up appointments
        in your area through our website. To get professional
        measure and installation services for your home,
        please visit your local store.
      </p>

      <div className="head-icon"><DrillIcon /></div>
      <h5>Get DIY Help</h5>
      <p>
        You can do it; we can help! Speak with someone who can walk you
        through measuring and installing your own window treatments.
      </p>

      <div className="contact-box">
        <a href={`tel:${config.supportPhoneNumber}`}>{config.supportPhoneNumber}</a>
      </div>

      <div className="head-icon"><HomeIcon /></div>
      <h5>Shop at Home</h5>
      <p>
        For a full-service, in-home shopping experience, book an appointment with
        our Shop at Home window covering experts.
      </p>
    </div>
    <div className="next">
      <a className="btn button-link" href="http://www.homedepot.com/services/blinds-installation/">
        <span className="text">Find out more</span> <RightChevron />
      </a>
    </div>
  </div>
);

export default CoveredByNobody;
